import axiosServices from "../utils/axios";
import { convertToSnakeCase } from "../utils/code-utils";
import { convertToCamelCase } from "../utils/code-utils";

import type { CrewMember } from "../utils/types/crew";

export const fetchCrewListData = async (jobId: string): Promise<CrewMember[]> => {
  const resData = await axiosServices.get("/crew", {
    params: { job_id: jobId },
  });
  const raw = resData.data.data;
  const records = Array.isArray(raw) ? raw : (raw?.records ?? []);
  return convertToCamelCase<CrewMember[]>(records) ?? [];
};

// POST /v1/crew is async — returns immediately with an ack; completion comes via WebSocket
export const processCrewDocumentData = async (params: {
  jobId: string;
  documentId?: string;
  key?: string;
  bucket?: string;
}): Promise<void> => {
  const inputData = convertToSnakeCase(params);
  await axiosServices.post("/crew", inputData);
};

export const addCrewMemberData = async (
  jobId: string,
  data: Partial<CrewMember>
): Promise<CrewMember> => {
  const inputData = convertToSnakeCase({ ...data, jobId });
  const response = await axiosServices.post(`/jobs/${jobId}/crew_member`, inputData);
  return convertToCamelCase<CrewMember>(response.data.data);
};

export const updateCrewMemberData = async (
  id: string,
  data: Partial<CrewMember>
): Promise<CrewMember> => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.put(`/crew/${id}`, inputData);
  return convertToCamelCase<CrewMember>(response.data.data);
};

export const deleteCrewMemberData = async (id: string): Promise<{ id: string }> => {
  await axiosServices.delete(`/crew/${id}`);
  return { id };
};
